"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcFormPhone = void 0;
var UseFieldMap_1 = __importDefault(require("@aperza/ui/lib/hook/UseFieldMap"));
var validator_1 = require("@aperza/validator");
var react_1 = __importDefault(require("react"));
var AcFormText_1 = require("./AcFormText");
var PHONE_FIELD_NAME = 'tel';
var AcFormPhone = function (props) {
    var onChange = props.onChange, required = props.required, label = props.label, placeholder = props.placeholder, initialValue = props.initialValue, onValidation = props.onValidation;
    var telProps = {
        tel: {
            fieldName: PHONE_FIELD_NAME,
            required: required,
            label: label ? label : '電話番号',
            constraint: {
                presence: { allowEmpty: required, message: '^電話番号は必須です。' },
                length: {
                    maximum: 20,
                    tooLong: '^電話番号は20文字以内でご入力ください。',
                },
            },
            placeholder: placeholder ? placeholder : '0123-45-6789',
            value: initialValue ? validator_1.PhoneUtil.formatNational(initialValue) : undefined,
        },
    };
    var _a = UseFieldMap_1.default(telProps), fieldMap = _a.fieldMap, updateFieldValue = _a.updateFieldValue, updateFieldErrorId = _a.updateFieldErrorId, validateField = _a.validateField, clearFieldMapErrorIds = _a.clearFieldMapErrorIds;
    var validatePhoneNumber = function () {
        // validate constraints first. ie. not more than maxLength, etc.
        var hasErrorOnConstraints = validateField(PHONE_FIELD_NAME) > 0;
        var fieldValue = fieldMap[PHONE_FIELD_NAME].value;
        if (hasErrorOnConstraints) {
            onValidation && onValidation(true);
            return;
        }
        else if (fieldValue && !validator_1.PhoneUtil.isValid(fieldValue)) {
            // only validate format if there is a value and no other constraint failed
            updateFieldErrorId(PHONE_FIELD_NAME, '電話番号の形式に誤りがあります。');
            onValidation && onValidation(true);
        }
        else {
            clearFieldMapErrorIds();
            // no errors, format number
            updateFieldValue(PHONE_FIELD_NAME, validator_1.PhoneUtil.formatNational(fieldMap[PHONE_FIELD_NAME].value));
            onValidation && onValidation(false);
        }
    };
    // allow full-width numbers
    var numberAndDashRegex = /^[0-9\-\uff10-\uff19\uff0d\b]+$/;
    var _handleOnChange = function (fieldName, value) {
        if (value === '' || numberAndDashRegex.test(value)) {
            updateFieldValue(fieldName, value);
            onChange && onChange(fieldName, value);
        }
    };
    return (react_1.default.createElement(AcFormText_1.AcFormText, __assign({}, fieldMap.tel, { clearable: true, onChange: _handleOnChange, onBlur: validatePhoneNumber })));
};
exports.AcFormPhone = AcFormPhone;
exports.default = AcFormPhone;
AcFormPhone.displayName = 'AcFormPhone';
//# sourceMappingURL=AcFormPhone.js.map